import { Box, Skeleton, Text } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { LoanProductBaseFieldConfig } from './LoanProductBaseFieldConfig';
import { LoanProductIntermediateCalcs } from './LoanProductIntermediateCalcs';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { LoanProductEntity } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/entity/LoanProductEntity';
import { PropertyTable } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/property/PropertyTable';

type LoanProductProps = {
  loanProductMechanics: CreditAgreement.DomainEntity.LoanProductMechanicsWithEntities;
};
export const LoanProduct = ({ loanProductMechanics }: LoanProductProps) => {
  if (!loanProductMechanics || !loanProductMechanics.entity) {
    return <Skeleton />;
  }

  return (
    <Box mt="20px" width="100%" p="20px" borderWidth="1px">
      <LoanProductEntity
        loanProductEntity={loanProductMechanics.entity}
        config={loanProductMechanics._config_}
      />

      <LoanProductBaseFieldConfig
        baseFields={loanProductMechanics._config_.baseFieldConfigs}
      />
      <LoanProductIntermediateCalcs
        intermediateCalcs={
          loanProductMechanics._config_.intermediateCalcConfigs
        }
      />

      <Text fontSize="20px" fontWeight="bold">
        Receivable Advance Rate
      </Text>
      <PropertyTable
        propertyPairs={[
          ['receivableAdvanceRate', loanProductMechanics.receivableAdvanceRate],
        ]}
        basePropertyKey=""
      />

      <Text fontSize="20px" fontWeight="bold">
        Receivable Valuation Rate
      </Text>
      <PropertyTable
        propertyPairs={[
          [
            'receivableValuationRate',
            loanProductMechanics.receivableValuationRate,
          ],
        ]}
        basePropertyKey=""
      />

      <Text fontSize="20px" fontWeight="bold">
        Concentration Limits
      </Text>
      {_.isEmpty(loanProductMechanics.concentrationLimits) && (
        <Text>No concentration limits have been configured</Text>
      )}
      {!_.isEmpty(loanProductMechanics.concentrationLimits) && (
        <PropertyTable
          propertyPairs={_.toPairs(loanProductMechanics.concentrationLimits)}
          basePropertyKey=""
        />
      )}

      <Text fontSize="20px" fontWeight="bold">
        Eligibility Tests
      </Text>
      {_.isEmpty(loanProductMechanics.eligibilityTests) && (
        <Text>No eligibility tests have been configured</Text>
      )}
      {!_.isEmpty(loanProductMechanics.eligibilityTests) && (
        <PropertyTable
          propertyPairs={_.toPairs(loanProductMechanics.eligibilityTests)}
          basePropertyKey=""
        />
      )}
    </Box>
  );
};
